import { mount } from "svelte";
import { loadLocale } from "wuchale/load-utils";

import { sweep } from "@-/data-loader/storage.svelte.ts";
import "#locales/svelte.loader.svelte.js";
import "#locales/ts.loader.js";
import App from "./App.svelte";
import { lang } from "./settings/prefs.ts";

const CALLBACK_PFX = "/api/oauth-callback/";
if (location.pathname.startsWith(CALLBACK_PFX)) {
	const { loginFor } = await import("@-/social-api/login.ts");
	await loginFor(location.pathname.slice(CALLBACK_PFX.length));
	navigation.navigate("/", { history: "replace" });
}

await loadLocale(lang.value);
document.documentElement.lang = lang.value;

setInterval(() => {
	sweep(60000 /* 1 min */);
}, 60000);

const app = mount(App, {
	target: document.querySelector("#app")!,
});

export default app;
